// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2Eslq","checkboxCol":"Table_checkboxCol__2CDIE","emailCol":"Table_emailCol__1W6Kw","actionCol":"Table_actionCol__2MdiX"};